import React from 'react';
import { Pressable } from 'react-native';
import { Text } from '@tamagui/core';
import { XStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';

type FilterButtonProps = {
  label: string;
  count: number;
  isActive: boolean;
  onPress: () => void;
  isDark: boolean;
  textColor: string;
};

export const FilterButton: React.FC<FilterButtonProps> = ({
  label,
  count,
  isActive,
  onPress,
  isDark,
  textColor,
}) => {
  return (
    <Pressable onPress={onPress} style={{ flex: 1 }}>
      <XStack
        backgroundColor={
          isActive
            ? COLORS.PRIMARY
            : isDark
            ? 'rgba(255, 255, 255, 0.1)'
            : 'rgba(0, 0, 0, 0.05)'
        }
        paddingVertical="$3"
        paddingHorizontal="$4"
        borderRadius={12}
        justifyContent="center"
        alignItems="center"
        gap="$2"
        borderWidth={1}
        borderColor={
          isActive
            ? COLORS.PRIMARY
            : isDark
            ? 'rgba(255, 255, 255, 0.2)'
            : 'rgba(0, 0, 0, 0.1)'
        }
      >
        <Text
          fontSize={16}
          fontWeight="700"
          color={isActive ? COLORS.WHITE : textColor}
        >
          {label}
        </Text>
        <XStack
          backgroundColor={
            isActive
              ? 'rgba(255, 255, 255, 0.3)'
              : isDark
              ? 'rgba(255, 255, 255, 0.2)'
              : 'rgba(0, 0, 0, 0.1)'
          }
          paddingHorizontal="$2"
          paddingVertical="$1"
          borderRadius={8}
          minWidth={24}
          justifyContent="center"
          alignItems="center"
        >
          <Text
            fontSize={12}
            fontWeight="700"
            color={isActive ? COLORS.WHITE : textColor}
          >
            {count}
          </Text>
        </XStack>
      </XStack>
    </Pressable>
  );
};


